import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { PlanoAcaoSituacao } from '../../models/plano-acao-situacao.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { PontoCriticoAcaoSituacaoService } from '../../services/ponto-critico-acao-situacao.service';

@Component({
  selector: 'app-pontos-criticos-acao-situacao-edit',
  templateUrl: './pontos-criticos-acao-situacao-edit.component.html',
  styleUrls: ['./pontos-criticos-acao-situacao-edit.component.scss']
})
export class PontosCriticosAcaoSituacaoEditComponent extends BaseFormComponent<PlanoAcaoSituacao> implements OnInit {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  idAcao: number;
  idEntrega: number;
  idIndicador: number;
  idPgIndicador: number;
  idPontoCriticoEntrega: number;
  idPontoCriticoIndicador: number;
  idPontoCriticoPgIndicador: number;
  idPontoCriticoProjeto: number;
  actionLabel: string = 'Nova';
  list: any;
  audit: AtualizacoesAudit;

  constructor(
    private situacaoService: PontoCriticoAcaoSituacaoService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.list = this.activatedRoute.snapshot.data['list'];

      if (this.activatedRoute.snapshot.params.idAcao) {
        this.idAcao = this.activatedRoute.snapshot.params.idAcao;
      }
      if (this.activatedRoute.snapshot.params.idPontoCritico) {
        this.idPontoCriticoProjeto = this.activatedRoute.snapshot.params.idPontoCritico;
      } else if (this.activatedRoute.snapshot.params.idPontoCriticoEntrega) {
        this.idPontoCriticoEntrega = this.activatedRoute.snapshot.params.idPontoCriticoEntrega;
        if (this.activatedRoute.snapshot.params.idEntrega) { // acessado a partir da aba de entregas
          this.idEntrega = this.activatedRoute.snapshot.params.idEntrega;
        }
      } else if (this.activatedRoute.snapshot.params.idPontoCriticoIndicador) {
        this.idPontoCriticoIndicador = this.activatedRoute.snapshot.params.idPontoCriticoIndicador;
        if (this.activatedRoute.snapshot.params.idIndicador) { // acessado a partir da aba de indicador
          this.idIndicador = this.activatedRoute.snapshot.params.idIndicador;
        }
      } else if (this.activatedRoute.snapshot.params.idPontoCriticoPgIndicador) {
        this.idPontoCriticoPgIndicador = this.activatedRoute.snapshot.params.idPontoCriticoPgIndicador;
        if (this.activatedRoute.snapshot.params.idPgIndicador) {
          this.idPgIndicador = this.activatedRoute.snapshot.params.idPgIndicador;
        }
      }
      this.initForm();
      this.loaded();
    });
  }

  validaIds() {
    // Valida se a situação do idSituacao na url da rota pertence ao idProjeto da rota
    if (!this.idPontoCriticoPgIndicador && this.entity.pf_id != this.idProjeto) { // projeto, agregador não possui idProjeto na rota
      this.voltar();
    }
    // valida se o id da situação na url da rota pertence à ação, ao ponto crítico, e à entrega ou indicador cujos ids estão na rota
    if (this.idPontoCriticoProjeto) {
      this.validaId(this.entity.critical_id, this.idPontoCriticoProjeto);
      this.validaId(this.entity.action_id, this.idAcao);
    } else if (this.idPontoCriticoEntrega) {
      if (this.idEntrega) {
        this.validaId(this.entity.prt_issue_id, this.idEntrega);
      }
      this.validaId(this.entity.prt_issue_critical_id, this.idPontoCriticoEntrega);
      this.validaId(this.entity.prt_issue_action_id, this.idAcao);
    } else if (this.idPontoCriticoIndicador) {
      if (this.idIndicador) {
        this.validaId(this.entity.ind_id, this.idIndicador);
      }
      this.validaId(this.entity.ind_critical_id, this.idPontoCriticoIndicador);
      this.validaId(this.entity.ind_action_id, this.idAcao);
    } else if (this.idPontoCriticoPgIndicador) {
      if (this.idPgIndicador) {
        this.validaId(this.entity.ind_id, this.idPgIndicador);
      }
      this.validaId(this.entity.ind_critical_id, this.idPontoCriticoPgIndicador);
      this.validaId(this.entity.ind_action_id, this.idAcao);
    }
  }

  validaId(id1: any, id2: any) {
    if (id1 != id2) {
      this.voltar();
    }
  }

  initForm() {
    if (this.entity?.id) {
      this.actionLabel = 'Editar';
      this.list = this.entity;
      this.validaIds();

      if (this.idPontoCriticoProjeto) {
        this.audit = {
          action_analysis_id: this.entity.id // entity de uma PlanoAcaoSituacao (PfActionAnalysis) de um Ponto Crítico (PfCritical) vinculado diretamente ao projeto
        };
      } else if (this.idPontoCriticoEntrega) {
        this.audit = {
          prt_issue_action_analysis_id: this.entity.id // entity de um PlanoAcaoSituacao (PfPrtIssueActionAnalysis) de um Ponto Crítico (PfPrtIssueCritical) vinculado diretamente a entrega
        };
      } else if (this.idPontoCriticoIndicador) {
        this.audit = {
          ind_action_analysis_id: this.entity.id // entity de um PlanoAcaoSituacao (PfIndActionAnalysis) de um Ponto Crítico (PfIndCritical) vinculado diretamente a indicador
        };
      } else if (this.idPontoCriticoPgIndicador) {
        this.audit = {
          pg_ind_action_analysis_id: this.entity.id // entity de um PlanoAcaoSituacao (PfPgIndActionAnalysis) de um Ponto Crítico (PfPgIndCritical) vinculado diretamente a indicador de um Projeto Agregador
        };
      }
    }

    this.form = new FormGroup({
      description: new FormControl('', [Validators.required]),
      dt_start: new FormControl(!this.list?.start ? null : this.list?.dt_start_action, [Validators.required]),
      dt_start_action: new FormControl({ value: this.list?.dt_start_action, disabled: true }),
      dt_deadline: new FormControl({ value: this.list?.dt_deadline, disabled: true }),
      deadline: new FormControl(null, [Validators.required]),
      prt_issue_action_stat_id: new FormControl(null, this.idPontoCriticoEntrega ? [Validators.required] : []),
      ind_action_stat: new FormControl(null, this.idPontoCriticoIndicador  ? [Validators.required] : []),
      action_stat_id: new FormControl(null, this.idPontoCriticoProjeto ? [Validators.required] : []),
    });

    if (this.entity) {
      this.form.patchValue(this.entity);
    }
  }

  typeStatusForm(): string {
    if (this.idPontoCriticoIndicador || this.idPontoCriticoPgIndicador) {
      return 'ind_action_stat';
    } else if (this.idPontoCriticoEntrega) {
      return 'prt_issue_action_stat_id'; // Campo Situacao contém uma fk para prt_issue_action_stat quando a entity é uma action de entrega (PfPrtIssueAction)
    } else {
      return 'action_stat_id'; // Campo Situacao contém uma fk para action_stat quando a entity é uma action (PfAction)
    }
  }

  voltar() {
    this.navigation.back();
  }

  getDataCreate(): PlanoAcaoSituacao {
    let data: PlanoAcaoSituacao;
    data = Object.assign({}, data, this.form.value);

    let formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!formatoDataRegex.test(data.dt_start)) {
      data.dt_start = formatDate(data.dt_start, 'DD/MM/YYYY');
    }
    if (!formatoDataRegex.test(data.deadline)) {
      data.deadline = formatDate(data.deadline, 'DD/MM/YYYY');
    }

    if (this.idPontoCriticoIndicador || this.idPontoCriticoPgIndicador) {
      data.ind_action_id = this.idAcao; // ação de ponto crítico de indicador de projeto ou de indicador de projeto agregador, usam o mesmo campo ind_action_id
    } else if (this.idPontoCriticoEntrega) {
      data.prt_issue_action_id = this.idAcao;
    } else {
      data.action_id = this.idAcao;
    }

    return data;
  }

  salvar(): void {
    if (this.form.valid && this.dataFormValid('dt_start', 'deadline')) {
      this.loading();

      if (this.entity?.id) {
        if (this.idPontoCriticoProjeto) {
          this.addSub(
            this.situacaoService.update(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Situação alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoEntrega) {
          this.addSub(
            this.situacaoService.entregaUpdate(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Situação alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoIndicador) {
          this.addSub(
            this.situacaoService.indicadorUpdate(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Situação alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoPgIndicador) {
          this.addSub(
            this.situacaoService.agregadorIndicadorUpdate(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Situação alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        }
      } else {
        if (this.idPontoCriticoProjeto) {
          this.addSub(
            this.situacaoService.create(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'pontos-criticos', this.idPontoCriticoProjeto, 'plano-acao', this.idAcao, 'situacao', res.id]);
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoEntrega) {
          this.addSub(
            this.situacaoService.entregaCreate(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  if (this.idEntrega) { // navegação a partir da aba de entregas
                    this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', this.idPontoCriticoEntrega, 'plano-acao', this.idAcao, 'situacao', res.id]);
                  } else { // navegação a partir da aba de pontos criticos
                    this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'entrega', this.idPontoCriticoEntrega, 'plano-acao', this.idAcao, 'situacao', res.id]);
                  }
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoIndicador) {
          this.addSub(
            this.situacaoService.indicadorCreate(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  if (this.idIndicador) { // navegação a partir da aba de indicadores
                    this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', this.idPontoCriticoIndicador, 'plano-acao', this.idAcao, 'situacao', res.id]);
                  } else { // navegação a partir da aba de pontos criticos
                    this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'indicador', this.idPontoCriticoIndicador, 'plano-acao', this.idAcao, 'situacao', res.id]);
                  }
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoPgIndicador) {
          this.addSub(
            this.situacaoService.agregadorIndicadorCreate(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  this.navigation.replace(['projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico', this.idPontoCriticoPgIndicador, 'plano-acao', this.idAcao, 'situacao', res.id]);
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        }
      }
    } else {
      this.markAsDirty();
    }
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }
}
